import { endPoints } from 'api/';
import { CREATE_INTEGRATION } from 'actions/types';

export function createIntegration(payload) {
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: CREATE_INTEGRATION,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        return await apiClient(endPoints.CREATE_INTEGRATION, payload);
      },
    };
    dispatch(action);
  };
}
